let constRouters = [
  {
    path: '/',
    component: () => import('../pages/index')
  },
  {
    path: '/single/page',
    component: () => import('../pages/page'),
    name:'single_page',
  },
  {
    path: '/designer/detail',
    component: () => import('../pages/designer/index'),
    name:'designer_detail',
  },
  // 推荐设计师
  {
    path: '/recommend/designer',
    component: () => import('../views/recommend/index'),
    name:'designer_recommend',
  },
  {
    path: '/company/detail',
    component: () => import('../pages/enterprise/index'),
    name:'enterprise_detail',
  },
  {
    path: '/search',
    component: () => import('../pages/search'),
    name:'search_detail',
  },
  {
    path: '/feedback',
    component: () => import('../pages/feedback'),
    name:'feedback_detail',
  },
  {
    path: '/course',
    component: () => import('../views/teachCourse/index'),
    name:'course_index',
  },
  {
    path: '/course/detail',
    component: () => import('../components/video/videoDetail'),
    name: 'video_detail',
    meta:{activeMenu:'/course'}
  },
  {
    path: '/found',
    component: () => import('../views/found/index'),
    name: 'found_index',
  },
  {
    path: '/work/detail',
    component: () => import('../components/work/detail'),
    name: 'work_detail',
    meta:{activeMenu:'/found'}
  },
  {
    path: '/job/detail',
    component: () => import('../views/found/position/detail'),
    name: 'job_detail',
    meta:{ activeMenu:'/found' }
  },
  {
    path: '/question/detail',
    component: () => import('../views/community/detail'),
    name: 'question_detail',
    meta:{ activeMenu:'/found' }
  },
  {
    path: '/partner',
    component: () => import('../views/supplier/index'),
    name: 'partner_index',
  },
  {
    path: '/partner/detail',
    component: () => import('../components/supplierDetail'),
    name:'partner_detail',
    meta:{ activeMenu:'/partner' }
  },
  {
    path: '/material',
    component: () => import('../views/material/index'),
    name: 'material_index',
  },
  {
    path: '/material/detail',
    component: () => import('../components/materialDetail'),
    name: 'material_detail',
    meta:{activeMenu:'/material'}
  },
  {
    path: '/answer',
    component: () => import('../views/answerQuestion/index'),
    name:'answer'
  },
  {
    path: '/answer/expert/list',
    component: () => import('../views/answerQuestion/expert/list'),
    name:'expert_list',
    meta:{activeMenu:'/answer'}
  },
  {
    path: '/answer/expert/home',
    component: () => import('../views/answerQuestion/expert/home'),
    name:'expert_home',
    meta:{activeMenu:'/answer'}
  },
  {
    path: '/answer/expert/expert_question',
    component: () => import('../views/answerQuestion/expert/homeQuestion'),
    name:'expert_question',
    meta:{activeMenu:'/answer'}
  },
  {
    path: '/answer/expert/rate',
    component: () => import('../views/answerQuestion/expert/rate'),
    name:'expert_rate',
    meta:{activeMenu:'/answer'}
  },
  {
    path: '/answer/my/question/detail',
    component: () => import('../views/answerQuestion/my/detail'),
    name:'my_question_detail',
    meta:{activeMenu:'/answer'}
  },
  {
    path: '/answer/detail/index',
    component: () => import('../views/answerQuestion/detail'),
    name:'detail_index'
  },
  {
    path: '/task',
    component: () => import('../views/task/index'),
    name: 'task_index',
  },
  {
    path: '/task/detail',
    component: () => import('../components/order/detail'),
    name: 'task_detail',
    meta:{activeMenu:'/task'}
  },
  {
    path: '/wx_url',
      component: () => import('../components/wx'),
    name: 'wx_url'
  },
  {
    path: '/inside_video',
    component: () => import('../components/video/inside/index'),
    name: 'inside_video'
  },
  {
    path: '/teacher/home',
    component: () => import('../pages/teacher/index'),
    name: 'teacher_home'
  },
  {
    path: '/teacher/propaganda',
    component: () => import('../components/teacherPropaganda/index'),
    name: 'teacher_propaganda'
  },
  {
    path: '/teacher/list',
    component: () => import('../views/teacher/index'),
    name: 'teacher_list'
  },
  {
    path: '/active/list',
    component: () => import('../views/activity/index'),
    name: 'active_list'
  },
  {
    path: '/active/detail',
    component: () => import('../views/activity/detail'),
    name: 'active_detail'
  },
  {
    path: '/active/sing',
    component: () => import('../views/activity/sing'),
    name: 'active_sing'
  },
  {
    path: '/active/diyform',
    component: () => import('../views/activity/diyform'),
    name: 'active_diyform'
  },
  {
    path: '/active/entry',
    component: () => import('../views/activity/entry'),
    name: 'active_entry'
  },
  {
    path: '/active/works',
    component: () => import('../views/activity/works'),
    name: 'active_works'
  },
  {
    path: '/active/notice',
    component: () => import('../views/activity/notice'),
    name: 'active_notice'
  },
  {
    path: '/active/workDetail',
    component: () => import('../views/activity/workDetail'),
    name: 'active_work_detail'
  },

  // {
  //   path: '/personal/competition/edit',
  //   component: () => import('../views/personal/competition/edit'),
  //   name: 'competition_edit'
  // },
]
export default constRouters



// WEBPACK FOOTER //
// ./src/router/constRouter.js